import { useTheme } from 'styled-components';
import LXSelector from './lxSelector';

interface LXSortSelectorProps {
  value: SortFilter;
  onSelect: (sortFilter: SortFilter) => void;
}

const LXSortSelector = (props: LXSortSelectorProps) => {
  const theme = useTheme();
  return (
    <LXSelector<SortFilter>
      dropdownHeaderWidth={160}
      dropdownItemWidth={160}
      value={props.value}
      values={['Newest', 'Oldest']}
      labels={[theme.texts.newest, theme.texts.oldest]}
      onSelect={props.onSelect}
    ></LXSelector>
  );
};

export default LXSortSelector;
